var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('universal-toolbar',{attrs:{"flat":false,"showDrawerMenu":true}}),_c('v-main',[_vm._t("default")],2),_c('v-footer',{attrs:{"app":"","absolute":""}},[_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }